import { LoanApplicationTabRouteParam } from 'constants/loanApplication';

export const ReadinessCheckId = {
  TRID_CLOCK: 'tridClock',
  E_CONSENT: 'eConsent',
  BORROWER_EMAILS: 'borrowerEmails',
  COMP_PLAN: 'compPlan',
  FEES_PRESENT: 'feesPresent',
  LOAN_FIELDS: 'loanFields',
};

export const ReadinessCheckStatus = {
  PASS: 'pass',
  FAIL: 'fail',
  MISSING_DATA: 'missingData',
};

export const ReadinessCheckSeverity = {
  HARD: 'hard',
  SOFT: 'soft',
};

export const READINESS_CHECK_DEEP_LINK = {
  [ReadinessCheckId.E_CONSENT]: { tab: LoanApplicationTabRouteParam.BORROWERS },
  [ReadinessCheckId.BORROWER_EMAILS]: { tab: LoanApplicationTabRouteParam.BORROWERS },
  [ReadinessCheckId.FEES_PRESENT]: { tab: LoanApplicationTabRouteParam.LOAN_FEES },
  [ReadinessCheckId.LOAN_FIELDS]: { tab: LoanApplicationTabRouteParam.PROPERTY_AND_LOAN },
};

export const HOMEOWNERS_INSURANCE_PREPAID_PATTERN = /homeowner|hazard|insurance/i;
